export default {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGIN_BLOCK: "LOGIN_BLOCK",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",

  LOGOUT: "LOGOUT",

  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_FAILED: "SIGNUP_FAILED",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",

  CHECK_AUTH_REQUEST: "CHECK_AUTH_REQUEST",
  CHECK_AUTH_FAILED: "CHECK_AUTH_FAILED",
  CHECK_AUTH_SUCCESS: "CHECK_AUTH_SUCCESS",

  RENEW_TOKEN_REQUEST: "RENEW_TOKEN_REQUEST",
  RENEW_TOKEN_FAILED: "RENEW_TOKEN_FAILED",
  RENEW_TOKEN_SUCCESS: "RENEW_TOKEN_SUCCESS"
};
